<template>
  <div
    v-show="active"
    class="bar-tool-tip"
    :style="{
      left: !isMobile ? mouse_x + 'px' : '0px',
      top: !isMobile ? mouse_y + 'px' : 'unset',
      bottom: isMobile ? '0' : 'unset',
      border: '2px solid' + tooltip_values.stroke_color,
      color: tooltip_values.font_color
    }"
    @click.self="closePopUp"
  >
    <div @click.self="closePopUp" class="industry large bolder">
      {{ industry }} INDUSTRY
    </div>
    <div
      @click.self="closePopUp"
      class="separator"
      :style="{ backgroundColor: tooltip_values.stroke_color }"
    ></div>
    <div @click.self="closePopUp" class="details large">
      On average, employees claimed a total of
      <span class="bold">£{{ totalSpent }} {{ tooltip_values.text }}</span>
      over the course of the pandemic.
    </div>
    <div
      @click.self="closePopUp"
      class="top-brands"
      v-if="tooltip_values.has_image == true"
    >
      <div class="title large bolder">TOP BRANDS OVERALL:</div>
      <div
        class="separator"
        :style="{ backgroundColor: tooltip_values.stroke_color }"
      ></div>
      <div class="image-list" @click.self="closePopUp">
        <div class="image">
          <img
            :src="
              require('../assets/img/' + tooltip_values.image_paths.image_1)
            "
          />
        </div>
        <div class="image">
          <img
            :src="
              require('../assets/img/' + tooltip_values.image_paths.image_2)
            "
          />
        </div>
        <div class="image">
          <img
            :src="
              require('../assets/img/' + tooltip_values.image_paths.image_3)
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BarToolTip",
  props: {
    active: Boolean,
    keepType: {},
    totalSpent: Number,
    industry: String,
    mouse_x: Number,
    mouse_y: Number
  },
  computed: {
    ...mapGetters({
      tooltip_values: "getToolTip",
      isMobile: "getIsMobile"
    })
  },
  methods: {
    closePopUp() {
      this.$emit("close", this);
    }
  }
};
</script>

<style lang="scss" scoped>
.bar-tool-tip {
  position: fixed;
  box-sizing: border-box;
  width: 410px;
  height: auto;
  padding: 30px 0;
  background-color: #fff;
  cursor: default;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  pointer-events: none;

  @media (max-width: 769px) {
    width: 100%;
    pointer-events: unset;
  }

  .industry {
    text-transform: uppercase;
  }

  .separator {
    height: 3px;
    width: 135px;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 15px;
  }
  .details {
    text-align: center;
    padding: 0 40px;
    letter-spacing: 0.6px;
  }
  .top-brands {
    margin-top: 50px;
    text-align: center;
    width: 100%;

    .image-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      flex: 1;
      padding: 0 40px;
      box-sizing: border-box;

      .image {
        width: 28%;
        height: auto;
        display: block;
        text-align: center;

        img {
          width: 100%;
          height: auto;
          max-height: 40px;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
